import { ApiClient } from '../../ApiClient';
import { CreateNoteDTO, GetNotesFiltersDTO, NoteDTO, UpdateNoteDTO } from '../dto/NotesDTO';

export class NotesDataSource {
  constructor(private api: ApiClient) {}

  async getNotes(filters?: GetNotesFiltersDTO): Promise<NoteDTO[]> {
    const response = await this.api.get<NoteDTO[]>('/notes', {
      params: filters
    });
    return response.data;
  }

  async createNote(note: CreateNoteDTO): Promise<NoteDTO> {
    const response = await this.api.post<NoteDTO>('/notes', note);
    return response.data;
  }

  async updateNote(id: string, updates: UpdateNoteDTO): Promise<NoteDTO> {
    const response = await this.api.put<NoteDTO>(`/notes/${id}`, updates);
    return response.data;
  }

  async deleteNote(id: string): Promise<void> {
    await this.api.delete(`/notes/${id}`);
  }
}
